export default "__VITE_ASSET__cp0aQzjB__"